
























































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';
import tutorial from '@/components/tutorial/tutorial';

import MenuReport from './navigation/menu-report.vue';
import MenuReportContextMenu from '@/views/layout/navigation/menu-report-context-menu.vue';
import MenuBase from './navigation/menu-base';
import MainMenuComplexTabsMixin from '@/views/layout/navigation/mixins/main-menu-complex-tabs-mixin';

import MenuDrilldown from '@/views/reports/views/menu-drilldown/menu-drilldown.vue';

import StatusPicker from '@/views/reports/pickers/status-picker.vue';
import PeriodPicker from '@/views/reports/pickers/period-picker.vue';

import TagSearch from '@/views/reports/pickers/tag-search.vue';
import AddMarks from '@/views/reports/pickers/add-marks/add-marks.vue';

import PagePicker from '@/views/reports/pickers/page-picker.vue';
import ViewPicker from '@/views/reports/pickers/view-picker.vue';
import MainMenuGrouping from '@/views/layout/navigation/grouping/main-menu-grouping.vue';
import ReportSettings from '@/views/reports/pickers/report-settings.vue';
import LoadingCircle from '@/components/loading-circle.vue';

import reportAPI from '@/services/rest/bemob/report';
import moment from 'moment';
import { pick, debounce, omit } from 'lodash';
import ReportFiltersCommon from '@/views/reports/report-filters-common';
import MenuTreeLevels from '@/views/reports/views/tree-levels.vue';
const md5 = require('md5');

const checkIsToday = range =>
    moment(range.from).isSame(moment(), 'day') && moment(range.to).isSame(moment(), 'day')

enum MainMenuLayoutType {
  tab = 0,
  tabCustom,
  delimiter
}

interface MainMenuLayoutTab {
  type: MainMenuLayoutType;
  key: string;
  icon?: string;
  title?: string;
  active?:  boolean;
  showCondition?: boolean;
  click?: (event?: any) => void;
  subItems?: MainMenuLayoutTab[];
  meta?: any;
}

import MenuItem from '@/components/menu/menu-item.vue';
import { forceCleanCache } from '@/services/utils/websocket';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import { GENERAL_PRESET } from '@/services/constants/report';
import Chart from '@/views/dashboard/config/chart.vue';
import { AppErrorEnum } from '@/services/models/Enums';
import query from '@/components/query/query-constructor';
import _ from 'lodash';

@Component({
  components: {
    StatusPicker,
    PeriodPicker,
    TagSearch,
    PagePicker,
    ViewPicker,
    MenuReport,
    MenuReportContextMenu,
    MenuDrilldown,
    AddMarks,
    MenuTreeLevels,
    MenuItem,
    MainMenuGrouping,
    ReportSettings,
    LoadingCircle,
    Chart
  },
})
export default class MainMenu extends mixins(
  IntercomMixin,
  UrlMixin,
  MenuBase,
  MainMenuComplexTabsMixin,
  mixins(
    ReportFiltersCommon,
    Chart
  )
) {
  refreshEffect: boolean = false;
  updatedFilters: number = 0;
  isChartLoading: boolean = false;
  showChartEmptyText: boolean = false;
  error: any = null;

  handleShareReportOpen() {
    this.bus.emit('open-dialog', { name: 'ShareReportDialog' });
  }

  get isMember() {
    return this.$store.state.user.isMember
  }

  get presetsList() {
    const presetsList = Object.values(this.$store.state.report.presets) as Preset[]
    return presetsList.map(item=>({
      key: item.presetId,
      title: item.presetId === GENERAL_PRESET ? this.t('____x.generalPreset') : item.presetName,
      click:()=>{
        this.$store.commit('setActivePreset', item.presetId);
        this.$store.commit('tableSetColumnsFilters', {})
        this.bus.emit('update-table-filters');
        this.handleApply({resetPagination:true})
      }
    }))
  }

  get isPeriodPickerVisible() {
    return !this.isLiveVisits;
  }

  get showViewPicker() {
    return this.isReport() && this.$store.getters.tableQueryForCurrentTab.treeLevels?.filter((item)=>!!item).length;
  }

  get isPageSizePickerVisible() {
    return !this.isLiveVisits;
  }

  get isPagePickerVisible() {
    return !this.isLiveVisits;
  }

  handleMetricsPickerOpen() {
    this.bus.emit('open-dialog', { name: 'ColumnsSettingsDialog' });
  }

  get filteredSelectedItems() {
    return this.$store.state.table.selectedItems
        ? this.$store.state.table.selectedItems.filter(({ DT_RowId }) => DT_RowId !== 'Unknown')
        : [];
  }

  get isAddMarksVissible() {
    const { grouping } = this.filteredSelectedItems[0] || {}

    return this.isMainTab ||
      this.isCustomTab ||
      grouping?.startsWith('reports-custom') ||
      this.mainTabs.includes(grouping?.replace('-name', '').replace('_', '-'))
  }

  get notReports() {
    return [ 'conversions', 'postbacks', 'errors', 'live-visits', 'live-clicks' ];
  }

  get isBasicReportPlusConversionsPostbacks() {
    return !['errors', 'live-visits', 'live-clicks' ].includes(this.computedType);
  }

  get isBasicReport() {
    return !this.notReports.includes(this.computedType);
  }

  get tutorial() {
    return tutorial(this);
  }

  @Watch('$store.state.tutorial.quickStartStep')
  runIntro(val: any) {
    this.tutorial.firstStep(val);
  }

  onBusRowReport(item: any, grouping: string) {
    this.report(item, grouping);
    // this.bus.emit('reload-report');
  }

  onBusRefreshChart() {
    this.chartReload();
  }

  mounted() {
    this.bus.on('refresh-chart', this.onBusRefreshChart);
    this.bus.on('row-report', this.onBusRowReport);
    this.bus.on('click-apply-filters', this.handleApply);
  }

  beforeDestroy() {
    this.bus.off('row-report', this.onBusRowReport);
    this.bus.off('refresh-chart', this.onBusRefreshChart);
    this.bus.off('click-apply-filters', this.handleApply);
  }

  toggleFilters() {
    this.$store.commit('showFilters', !this.$store.state.report.showFilters);
  }

  toggleSearch() {
    this.$store.commit('showSearch', !this.$store.state.report.showSearch);
  }

  chart(v: any) {
    this.$emit('showCharts');
    this.$store.commit('tableChartOpen', !this.$store.state.table.chartOpen);
  }

  get currentHash() {
    const currentHashVars = ()=>{
      const { searchBy, textValue, tagsValue, marksValue, tagsLogicalRelation, textLogicalRelation, marksFilterMode } = this.$store.getters.tableQueryTemporarySearch;
      const { treeLevels, view, from, to, timezone, compareEnabled, compareFrom, compareTo, compareDate } = this.$store.getters.tableQueryTemporaryForCurrentTab;
      const searchParams = {
        ...(searchBy?.startsWith('text') ? { searchBy:'text',textValue, textLogicalRelation } : {}),
        ...(searchBy === 'marks' || searchBy?.startsWith('marks-') ? {
          searchBy: 'marks',
          marksValue,
          marksFilterMode: marksFilterMode
            || (searchBy?.includes('exclude') ? 'exclude' : 'include')
        } : {}),
        ...(searchBy?.startsWith('tags') ? { searchBy:'tags',tagsValue, tagsLogicalRelation } : {}),
      }

      switch(this.$route.name) {
        case 'app.live-clicks':
        case 'app.live-visits':
          return {};

        case 'app.conversions':
          return {
            from,
            to,
            searchParams
          }
        case 'app.postbacks':
        case 'app.errors':
          return {
            from,
            to,
            searchParams
          }

        default:
          return {
            from,
            to,
            timezone,
            ...(this.$store.getters.reportParams.compareEnabled ? {compareEnabled,compareFrom,compareTo,compareDate} : {}),
            searchParams,
            treeLevels,
            view
          }
      }
    }
    return md5(JSON.stringify(currentHashVars()));
  }

  get oldHash() {
    const oldHashVars = ()=>{
      const { searchBy, textValue, tagsValue, marksValue, tagsLogicalRelation, textLogicalRelation, marksFilterMode } = this.$store.getters.tableQuerySearch;
      const { treeLevels, view, from, to,timezone,compareEnabled,compareFrom,compareTo,compareDate  } = this.$store.getters.tableQueryForCurrentTab;
      const searchParams = {
        ...(searchBy?.startsWith('text') ? { searchBy:'text',textValue, textLogicalRelation } : {}),
        ...(searchBy === 'marks' || searchBy?.startsWith('marks-') ? {
          searchBy: 'marks',
          marksValue,
          marksFilterMode: marksFilterMode
            || (searchBy?.includes('exclude') ? 'exclude' : 'include')
        } : {}),
        ...(searchBy?.startsWith('tags') ? { searchBy:'tags',tagsValue, tagsLogicalRelation } : {}),
      }

      switch(this.$route.name) {
        case 'app.live-clicks':
        case 'app.live-visits':
          return {};

        case 'app.conversions':
          return {
            from,
            to,
            searchParams
          }
        case 'app.postbacks':
        case 'app.errors':
          return {
            from,
            to,
            searchParams
          }

        default:
          return {
            from,
            to,
            timezone,
            ...(this.$store.getters.reportParams.compareEnabled ? {compareEnabled,compareFrom,compareTo,compareDate} : {}),
            searchParams,
            treeLevels,
            view,
          }
      }
    }
    return md5(JSON.stringify(oldHashVars()));
  }

  get isParamsChanged() {
    return this.currentHash !== this.oldHash;
  }

  @Watch('isParamsChanged')
  onIsParamsChangedChanged(value: boolean, oldValue: boolean) {
    if(value !== oldValue) {
      this.refreshEffect = false;
      this.$nextTick(() => {
        this.refreshEffect = true;
        setTimeout(() => this.refreshEffect = false, 1000);
      });
    }
  }

  handleApply(params:{resetPagination:boolean}) {
    if(!this.isParamsChanged) forceCleanCache();
    this.bus.emit('apply-filters');
    this.bus.emit('reload-report');
  }

  get tableFilters() {
    return pick(this.$store.state.table.query, ['status', 'date', 'currency', 'limit'])
  }

  get showChart(): boolean {
    return this.$store.state.table.chartOpen && (this.$route.path || '').includes('/report');
  }

  @Watch('$store.state.table.chartOpen')
  onShowChartChanged(value: boolean) {
    if(value) {
     this.getChartData();
    }
  }


  // tapRefresh(value: number) {
  //   this.refreshEffect = true;
  //   setTimeout(() => this.refreshEffect = false, 1000);
  //   this.updatedFilters = value;
  // }

  chartReload() {
    if (this.showChart) {
      this.getChartData();
    }
  }

  getChartData() {
    this.showChartEmptyText = false;
    let params = omit(this.$store.getters.reportParams,['limit','offset','formatResponse',
      'orderBy','orderDir','tree','view','compareEnabled','compareDate','compareTo','compareFrom']);

    params = {
      ...params,
      ...this.getReportFilters(),
      columns:params.columns?.filter(column => this.$store.getters.supportedMetricsAsObject[column])
    }

    const {selectedWorkspaces, workspaces} = this.$store.state.user;
    if(selectedWorkspaces?.length===workspaces?.length){
      delete params.workspaceIds
    }else{
      params.workspaceIds = selectedWorkspaces;
    }

    if(this.$store.getters.tableQueryForCurrentTab.compareEnabled){
      const {compareFrom, compareTo, compareDate} = this.$store.getters.tableQueryForCurrentTab
      params.compareFrom = compareFrom;
      params.compareTo = compareTo;
      params.compareDate = compareDate;
    }


    if(params.columns.length === 0) {
      this.showChartEmptyText = true;
      return;
    }

    this.isChartLoading = true
    this.error = null;
    this.chartOptions = JSON.parse(JSON.stringify(this.initialChartOptions));
    this.chartOptions.compareEnabled = this.$store.getters.tableQueryForCurrentTab.compareEnabled;

    new reportAPI()
    .getAggregatedReport(this.aggregatedValue,  params)
    .then((res: any) => {
      this.handleChartResponse({
        data:res.data.payload.data,
        isCompare:false
      })
      if(res.data.payload.compareData){
        this.handleChartResponse({
          data:res.data.payload.compareData,
          isCompare:true
        })
      }
    }).catch((error) => (this.error = error))
    .finally(() => {
      this.isChartLoading = false;
    });
  }

  get isDataRetentionTooOldDataRetrieved() {
    return this.error?.response?.status === 402 && this.error?.response?.data?.message === AppErrorEnum.dataRetentionTooOldDataRetrieved;
  }

  get reportsWithStatusPickerButton() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks'];
  }

  get hasStatusPicker() {
    return this.reportsWithStatusPickerButton.indexOf(this.$route.params.type) !== -1;
  }

  get route() {
    return this.$route.name || '';
  }

  get path() {
    return this.$route.path || '';
  }

  @Watch('$route.params.type')
  updateActive() {
    //this.showChart = false;
    this.updatedFilters = 0;
  }


  @Watch('$route.params')
  onRouteParamsReportChanged(value: any, oldValue: any) {
    if(value !== oldValue) {
      // this.$nextTick(() => {

      // });
      //this.chartReloadDebounced();
    }
  }

  @Watch('$store.state.table.loading')
  tableLoads() {
    this.updatedFilters = 0;
  }

  toggleCharts() {
    const highcharts = this.$refs.highcharts as any;
    const allHidden = this.isAllChartHidden;
    highcharts.chart.series.forEach((item)=>{
      item.setVisible(allHidden,false)
    })
    highcharts.chart.redraw();
  }
}
